<template>
	<v-dialog v-model="modal" max-width="500px">
        <v-card>
            <v-card-title class="headline">Are you sure you want to delete this item?</v-card-title>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close()">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="deleteItem()">OK</v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

	export default {
		name: 'DeleteDialog',
        components: {  },
        props: ['modal', 'item', 'close', 'action', 'isUser'],
		data: () => {
			return {}
        },
        
        methods: {
            deleteItem(){
                let id = this.isUser ? this.item.user.id : this.item.id;

                this.$store.dispatch(this.action, id);
                this.close();
            }
        }
	}
</script>

<style>

</style>
